/* eslint-disable global-require */
const List = () => import(/* webpackChunkName: "about-bundle" */ './RankingOportunidadeMelhoria.vue');

export default [
  {
    name: 'rankingoportunidademelhoria.index',
    path: '/ranking-oportunidade-melhoria',
    meta: {
      requiresAuth: true,
      breadcrum: 'Ranking Oportunidade Melhoria',
      icon: 'chart-line',
      can: 'analisecomsc',
      on: 'autorizacao',
      neto: true,
    },
    component: List,
  },
];
